<template>
  <section class="container">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          style="width:300px"
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          placeholder="请选择项目"
          @change="getDeviceList"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="网点设备" prop="device_id" ref="device_id">
        <a-select
          v-model="form.device_id"
          showSearch
          :filterOption="filterOption"
          style="width:300px"
          placeholder="请选择网点设备"
        >
          <a-select-option
            v-for="(item, i) in deviceList"
            :key="i"
            :value="item.device_id"
            >{{ item.device_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="进场商品">
        <table style="width:100%">
          <thead>
            <th>商品名称</th>
            <th>商品图</th>
            <th>数量</th>
          </thead>
          <tbody>
            <tr
              v-show="goodsList.length > 0"
              v-for="(item, key) in goodsList"
              :key="key"
            >
              <td>
                {{ item.brand_name }}
              </td>
              <td><img :src="item.imageUrl.url_thumb" alt="" /></td>
              <td>
                <a-input-number
                  v-model="item.inventory"
                  :min="0"
                  decimalSeparator="0"
                />
              </td>
            </tr>
            <tr class="noData" v-show="goodsList.length == 0">
              <td></td>
              <td>暂无</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button style="margin-right: 10px;" @click="resetForm">
          重置
        </a-button>
        <a-button type="primary" @click="onSubmit">
          确认
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </section>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        project_id: "",
        device_id: ""
      },
      proList: [],
      deviceList: [],
      goodsList: [],
      rules: {
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        device_id: [
          {
            required: true,
            message: "请选择网点设备",
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.getPro();
    this.getGoods();
  },
  methods: {
    getGoods() {
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Brand/getBrandList";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.goodsList = res.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    getDeviceList() {
      this.form.device_ids = [];
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/getListData";
      let params = {
        project_id: this.form.project_id,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          this.deviceList = res.data.data;
          // console.log(this.deviceList);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    verify() {
      let fls = true;
      if (this.goodsList != "") {
        this.goodsList.forEach(element => {
          if (element.inventory == "") {
            fls = false;
          }
        });
      }
      if (!fls) {
        this.$message.error("请选择商品");
      }
      return fls;
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.equipment +
            "Project/comeInmaterialnew";
          let brand_list_json = [];
          this.goodsList.forEach(item => {
            if (item.inventory != undefined) {
              brand_list_json.push({
                inventory: item.inventory,
                brand_id: item.id
              });
            }
          });
          //   console.log(brand_list_json);
          let params = {
            token: window.localStorage.getItem("xnwfPcToken"),
            device_id: this.form.device_id,
            brand_list_json: JSON.stringify(brand_list_json)
          };
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$emit("hideInMachineAddGoods", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.selectedAisle();
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;

  table {
    width: 60%;
    td,
    th {
      text-align: left;
      padding: 0 10px;
      border: 1px solid #ccc;

      img {
        height: 30px;
        width: 30px;
      }
    }
    th {
      background: #ededed;
    }
    .noData {
      border: 1px solid #ccc;

      td {
        border: none;
      }
    }
  }
}
</style>
